import { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Zap, X } from "lucide-react";

/** Amber banner shown when a free user is nearly out of prediction credits. */
export default function CreditNudge({ credits, onTopUp }) {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("credit_nudge_dismissed") === "1");

  if (dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem("credit_nudge_dismissed", "1");
    setDismissed(true);
  };

  return (
    <motion.div initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 pt-4">
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-[#F59E0B]/30 bg-[#F59E0B]/[0.08] px-4 py-3" data-testid="credit-nudge-banner">
        <div className="flex items-center gap-2.5 min-w-0">
          <Zap className="w-4 h-4 text-[#F59E0B] shrink-0" />
          <div className="text-xs text-gray-200">
            <span className="font-bold text-white">
              {credits === 0 ? "You're out of prediction credits." : `Only ${credits} prediction credit${credits === 1 ? "" : "s"} left.`}
            </span>{" "}
            Top up or go Premium to keep the AI predictions coming.
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button data-testid="credit-nudge-topup-btn" size="sm" onClick={onTopUp} className="bg-[#F59E0B] text-black hover:bg-[#F59E0B]/90 font-bold h-8 text-xs">
            <Zap className="w-3.5 h-3.5 mr-1.5" /> Top up
          </Button>
          <button data-testid="credit-nudge-dismiss-btn" onClick={dismiss} className="p-1.5 rounded-full hover:bg-white/10 text-gray-400 hover:text-white transition-colors" title="Dismiss">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </motion.div>
  );
}
